import Vue from 'vue';
import Components from '~/components';
Vue.use(Components);
